import styled, { css } from 'styled-components';

const errorState = css`
  border-color: ${({ theme }) => theme.colors.error};
  background-color: ${({ theme }) => theme.colors.errorBg};
`;

const fieldBase = css<{ $hasError?: boolean }>`
  width: 100%;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  padding: 1rem 1.4rem;
  font-size: 1.4rem;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.darkSlate};
  box-sizing: border-box;
  outline: none;
  ${({ $hasError }) => $hasError && errorState};
`;

export const Field = styled.div`
  margin-bottom: 1.2rem;
`;

export const Label = styled.label`
  display: block;
  font-size: 1.2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.slate};
  margin-bottom: 0.6rem;
`;

export const Input = styled.input<{ $hasError?: boolean }>`
  ${fieldBase};
`;

export const Textarea = styled.textarea<{ $hasError?: boolean }>`
  ${fieldBase};
  resize: vertical;
`;

export const Select = styled.select<{
  $hasError?: boolean;
  $disabled?: boolean;
}>`
  ${fieldBase};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`;

export const ErrorText = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.error};
  margin-top: 0.4rem;
`;

export const Hint = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-top: 0.4rem;
`;

export const PhoneInputWrap = styled.div<{ $hasError?: boolean }>`
  .PhoneInput {
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    border: 0.1rem solid
      ${({ $hasError, theme }) =>
        $hasError ? theme.colors.error : theme.colors.border};
    border-radius: 1rem;
    padding: 0 1.2rem;
    ${({ $hasError, theme }) =>
      $hasError && `background-color: ${theme.colors.errorBg};`}
  }

  .PhoneInputInput {
    border: none;
    outline: none;
    background: transparent;
    font-family: inherit;
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.darkSlate};
    padding: 1rem 0;
    min-width: 0;
  }

  .PhoneInputCountrySelect {
    color: ${({ theme }) => theme.colors.darkSlate};
  }

  .PhoneInputCountrySelectArrow {
    color: ${({ theme }) => theme.colors.slateGrey};
    opacity: 0.6;
  }
`;

export const CountryRoot = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const CountryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0.6rem 0.6rem 0.6rem 0;
  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

export const CountryGlobe = styled.span`
  font-size: 1.6rem;
  line-height: 1;
`;

export const CountryChevron = styled.span`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const CountryDropdown = styled.div`
  position: fixed;
  z-index: 1000;
  width: 28rem;
  max-width: calc(100vw - 1.6rem);
  background: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  box-shadow: 0 1.2rem 3.2rem rgba(0, 0, 0, 0.18);
  overflow: hidden;
`;

export const CountrySearch = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: none;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
  outline: none;
  padding: 1.1rem 1.4rem;
  font-family: inherit;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.darkSlate};
  background: transparent;
`;

export const CountryList = styled.div`
  max-height: 24rem;
  overflow-y: auto;
`;

export const CountryOption = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  width: 100%;
  border: none;
  cursor: pointer;
  padding: 0.9rem 1.4rem;
  font-family: inherit;
  font-size: 1.4rem;
  text-align: left;
  background: ${({ $active, theme }) =>
    $active ? theme.colors.surface : 'transparent'};
  color: ${({ theme }) => theme.colors.darkSlate};
  &:hover {
    background: ${({ theme }) => theme.colors.surface};
  }
  .PhoneInputCountryIcon {
    width: 2rem;
    flex-shrink: 0;
  }
`;

export const CountryOptionName = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CountryOptionDial = styled.span`
  color: ${({ theme }) => theme.colors.slateGrey};
  font-size: 1.3rem;
  flex-shrink: 0;
`;

export const CountryEmpty = styled.div`
  padding: 1.4rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.slateGrey};
  font-size: 1.3rem;
`;

export const CheckRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  cursor: pointer;
`;

export const CheckLabel = styled.span`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.darkSlate};
  line-height: 1.4;
`;
